import { render, staticRenderFns } from "./SearchReservationsCommissionsAdmin.vue?vue&type=template&id=48aa7530&"
import script from "./SearchReservationsCommissionsAdmin.vue?vue&type=script&lang=js&"
export * from "./SearchReservationsCommissionsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports